/**
 * UI
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides the application store for all values related to the app gui.
 */
import { PAGE_AREA } from '../../constants';

export default {
  state: {
    stepActive: -1,
    visualizationWarning: '',
    metric: PAGE_AREA !== 'US' ? true : false,
    loading: false,
  },
  mutations: {
    SET_ACTIVE_STEP(currentState, payload) {
      currentState.stepActive = payload;
    },

    // VISUALIZATION WARNING
    SET_VISUALIZATION_WARNING(currentState, payload) {
      currentState.visualizationWarning = payload;
    },

    // METRIC
    SET_METRIC(currentState, payload) {
      currentState.metric = payload;
    },
    SET_LOADING(currentState, payload) {
      currentState.loading = payload;
    },
  },
  actions: {
    setActiveStep(context, payload) {
      context.commit('SET_ACTIVE_STEP', payload);
    },
    goToStep(context, payload) {
      if (context.state.stepActive > payload) {
        context.commit('SET_ACTIVE_STEP', payload);
      }
    },
    setTable(context) {
      context.commit('SET_ACTIVE_STEP', 1);
    },
    nextStep(context) {
      context.commit('SET_ACTIVE_STEP', context.state.stepActive + 1);
    },

    // VISUALIZATION WARNING
    setVisualizationWarning(context, payload) {
      context.commit('SET_VISUALIZATION_WARNING', payload);
    },

    // METRIC
    setMetric(context, payload) {
      context.commit('SET_METRIC', payload);
    },
    setLoading(context, payload) {
      context.commit('SET_LOADING', payload);
    },
  },
  getters: {
    stepActive(state) {
      return state.stepActive;
    },
    visualizationWarning(state) {
      return state.visualizationWarning;
    },
    metric(state) {
      return state.metric;
    },
    loading(state) {
      return state.loading;
    },
  },
};
